import { render, staticRenderFns } from "./energyGoldDetail.vue?vue&type=template&id=06df6d18&scoped=true&"
import script from "./energyGoldDetail.vue?vue&type=script&lang=js&"
export * from "./energyGoldDetail.vue?vue&type=script&lang=js&"
import style0 from "./energyGoldDetail.vue?vue&type=style&index=0&id=06df6d18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df6d18",
  null
  
)

export default component.exports